export default {
  title: "Welcome to Antipartido",
  subtitle: "Create your digital citizen identity to participate in the democracy of the future",
  whatIs: {
    title: "What is Antipartido?",
    description:
      "A decentralized civic platform that allows Mexican citizens to participate in government decisions through blockchain technology, ensuring transparency and anonymity in every vote.",
    features: {
      anonymous: "100%\nAnonymous",
      verifiable: "Verifiable on\nBlockchain",
      biometric: "Biometric\nSecurity",
      oneVote: "One Citizen =\nOne Vote",
    },
  },
  buttons: {
    connect: "CONNECT",
    register: "Register",
  },
  or: "or",
  faqLink: "Have questions? See frequently asked questions",
}
